/**
 * UC-01: RunGameTick
 * TOGAF Application ABB — orchestrates one simulation tick without UI/framework deps.
 */
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { RunGameTickInput, RunGameTickOutput } from '../dto/RunGameTickDto';
import { ProcessGameTickOrchestrator } from './ProcessGameTickOrchestrator';

export interface RunGameTickDependencies {
  orchestrator: ProcessGameTickOrchestrator;
  logger?: IAppLogger;
}

export class RunGameTickUseCase {
  constructor(private readonly deps: RunGameTickDependencies) {}

  execute(input: RunGameTickInput): RunGameTickOutput {
    const simulation = this.deps.orchestrator.execute({
      grid: input.grid,
      stats: input.stats,
      tickNumber: input.tickNumber,
    });

    this.deps.logger?.log('debug', 'tick.completed', {
      tickNumber: input.tickNumber,
      netBudget: simulation.netBudget,
      netComp: simulation.netComp,
      dailyThreat: simulation.dailyThreat,
      violations: simulation.violations.length,
    });

    return {
      grid: simulation.grid,
      stats: input.stats,
      research: input.research,
      netBudget: simulation.netBudget,
      netComp: simulation.netComp,
      dailyThreat: simulation.dailyThreat,
      deltas: simulation.deltas,
      buildingCounts: simulation.buildingCounts,
      revenueHalted: simulation.revenueHalted,
      violations: simulation.violations,
      violationTiles: simulation.violationTiles,
      breakdown: simulation.breakdown,
      orgImpact: simulation.orgImpact,
    };
  }
}